import uni from '../assets/projects/uniportal.png'
import hotel from '../assets/projects/hotel.png'
import cbt from '../assets/projects/cbtapp.png'
import chess from '../assets/projects/chess.png'
import webuzz from '../assets/projects/webuzz.png'
import chatbot from '../assets/projects/chatbot.png'
import sms from '../assets/projects/sms.png'
import { RiCompassLine } from 'react-icons/ri'
import {
  SiExpress,
  SiJava,
  SiHaskell,
  SiPusher,
  SiVisualstudiocode,
  SiPostman,
  SiMicrosoftaccess,
  SiMicrosoftexcel,
} from 'react-icons/si'
import cl1 from '../assets/clients/client1.jpg'
import cl2 from '../assets/clients/client2.jpeg'
import cl3 from '../assets/clients/client3.png'
import cl4 from '../assets/clients/client4.png'
import cl5 from '../assets/clients/client5.JPG'
import {
  DiNetbeans,
  DiJavascript,
  DiReact,
  DiHtml5,
  DiCss3,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiDjango,
  DiHeroku,
  DiPhp,
  DiGit,
  DiMysql,
  DiFirebase,
  DiBootstrap,
} from 'react-icons/di'
import { MdOutlineEmail } from 'react-icons/md'
import { RiMessengerLine } from 'react-icons/ri'
import { BsWhatsapp } from 'react-icons/bs'

export const contact_optons = [
  {
    icon: <MdOutlineEmail className='contact__option-icon' />,
    title: 'Email',
    link: 'mailto:mamt4real@gmail.com',
    username: 'mamt4real@gmail.com',
  },
  {
    icon: <RiMessengerLine className='contact__option-icon' />,
    title: 'Messenger',
    link: 'https://m.me/mamt4real',
    username: 'mamt4real@gmail.com',
  },
  {
    icon: <BsWhatsapp className='contact__option-icon' />,
    title: 'WhatsApp',
    link: 'https://api.whatsapp.com/send?phone=+2348064241674',
    username: '+234 80642 41674',
  },
]

export const services = [
  {
    title: 'Web Development',
    list: [
      'Responsive frontend web designs.',
      'Developing and deploying REST API(s).',
      'Server-Side-Rendered Web Pages.',
      'API integrations.',
      'Cloud Databases Integration.',
    ],
  },
  {
    title: 'Application Packages',
    list: [
      'Client based custom Database Solutions with Microsoft Access',
      'Data Presentation and Analysis usin Microsoft Excel',
      'Data Exploration and Prediction with Jupyter notebook',
      'Game Development with Unity and Godot (learning)',
    ],
  },
  {
    title: 'Teaching / Coaching',
    list: [
      'Object-Oriented and Functional Programming Languages Tutoring',
      'Computer Science courses tutoring',
      'Simplification of Mathematical Problems using local dialect',
      "Qur'an recitaion and memorization mentoring.",
    ],
  },
]

export const clients = [
  {
    img: cl1,
    name: "Rufa'i",
    review: 'An Excellent Programmer',
  },
  {
    img: cl2,
    name: 'Hafsat',
    review: 'Always on time, good inter-personal relationship',
  },
  {
    img: cl3,
    name: 'Chiroma',
    review: 'A gentle man and a programmer',
  },
  {
    img: cl4,
    name: 'Mubarak',
    review: 'A Diligent Person, genius in the making',
  },
  {
    img: cl5,
    name: "Adda'i",
    review: 'An Excellent Programmer',
  },
]

export const experiences = {
  frontend: [
    {
      skill: 'HTML',
      icon: <DiHtml5 className='experience__icon' />,
    },
    {
      skill: 'CSS',
      icon: <DiCss3 className='experience__icon' />,
    },
    {
      skill: 'Javascript',
      icon: <DiJavascript className='experience__icon' />,
    },
    {
      skill: 'Bootsrap',
      icon: <DiBootstrap className='experience__icon' />,
    },
    {
      skill: 'React',
      icon: <DiReact className='experience__icon' />,
    },
    {
      skill: 'Django',
      icon: <DiDjango className='experience__icon' />,
    },
  ],
  tools: [
    {
      tool: 'VS Code',
      icon: <SiVisualstudiocode className='experience__icon' />,
    },
    {
      tool: 'Postman',
      icon: <SiPostman className='experience__icon' />,
    },
    {
      tool: 'Compass',
      icon: <RiCompassLine className='experience__icon' />,
    },
    {
      tool: 'Netbeans',
      icon: <DiNetbeans className='experience__icon' />,
    },
    {
      tool: 'Ms Access',
      icon: <SiMicrosoftaccess className='experience__icon' />,
    },
    {
      tool: 'Ms Excel',
      icon: <SiMicrosoftexcel className='experience__icon' />,
    },
  ],
  backend: [
    {
      skill: 'NodeJs',
      icon: <DiNodejs className='experience__icon' />,
    },
    {
      skill: 'MongoDB',
      icon: <DiMongodb className='experience__icon' />,
    },
    {
      skill: 'ExpressJs',
      icon: <SiExpress className='experience__icon' />,
    },
    {
      skill: 'MySQL',
      icon: <DiMysql className='experience__icon' />,
    },
    {
      skill: 'Git',
      icon: <DiGit className='experience__icon' />,
    },
    {
      skill: 'Java',
      icon: <SiJava className='experience__icon' />,
    },
    {
      skill: 'Python',
      icon: <DiPython className='experience__icon' />,
    },
    {
      skill: 'PHP',
      icon: <DiPhp className='experience__icon' />,
    },
    {
      skill: 'Haskell',
      icon: <SiHaskell className='experience__icon' />,
    },
    {
      skill: 'Firebase',
      icon: <DiFirebase className='experience__icon' />,
    },
    {
      skill: 'Heroku',
      icon: <DiHeroku className='experience__icon' />,
    },
    {
      skill: 'Pusher',
      icon: <SiPusher className='experience__icon' />,
    },
  ],
}

export const projects = [
  {
    name: 'Students Portal',
    img: uni,
    gitlink: 'university-portal',
    livelink: 'https://confident-brown-a77459.netlify.app/',
    desc: 'Student Portal design to handle students higher institution. It manges course registration, result system with GPA calculations and graduation requirements, also keep track of payments, and lots more !',
  },
  {
    name: 'CBT APP',
    img: cbt,
    gitlink: 'cbt',
    livelink: 'https://cbt.com',
    desc: 'A computer based test web app, allows you to create an exam, schedule it, upload questions, and when the exm is finished download the results in excel format.',
  },
  {
    name: 'School Management System',
    img: sms,
    gitlink: 'sms',
    livelink: '',
    desc: 'A school management website for secondary (and/or primary) schools. It contain the the school landing page a news/blog outlet and admin panel to mange students, results, payments, promotions and lots more',
  },
  {
    name: 'Covid-19 Chatbot',
    img: chatbot,
    gitlink: 'chatbot',
    livelink: 'https://mamt4real.github.io/chatbot',
    desc: 'A simple chatbot that responds to basic questions about covid-19.',
  },
  {
    name: 'CHESS',
    img: chess,
    gitlink: 'CHESS',
    livelink: 'https://mamt4real.github.io/CHESS',
    desc: 'A chess game engine. play multiplayer or against an AI, with multiple level of difficulty',
  },
  {
    name: 'Webuzz',
    img: webuzz,
    gitlink: 'webuzz-api',
    livelink: '',
    desc: 'A Simple blog website, where users can write and publish aricles of their choice',
  },
]
